/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerReadingLevelEnum = {
    Er: 'ER',
    _1A: '1A',
    _1B: '1B',
    _1C: '1C',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3A: '3A',
    _3B: '3B',
    _3C: '3C',
    _4A: '4A',
    _4B: '4B',
    _4C: '4C',
    _5A: '5A',
    _5B: '5B',
    _5C: '5C',
    _6A: '6A',
    _6B: '6B',
    _6C: '6C',
    _7A: '7A',
    _7B: '7B',
    _7C: '7C',
    _8A: '8A',
    _8B: '8B',
    _8C: '8C',
    _9A: '9A',
    _9B: '9B',
    _9C: '9C',
    _10A: '10A',
    _10B: '10B',
    _10C: '10C',
    _11A: '11A',
    _11B: '11B',
    _11C: '11C',
    _12A: '12A',
    _12B: '12B',
    _12C: '12C'
};
/**
 * Check if a given object implements the PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInner interface.
 */
export function instanceOfPostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInner(value) {
    if (!('readingLevel' in value) || value['readingLevel'] === undefined)
        return false;
    if (!('sisId' in value) || value['sisId'] === undefined)
        return false;
    if (!('studentId' in value) || value['studentId'] === undefined)
        return false;
    return true;
}
export function PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerFromJSON(json) {
    return PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerFromJSONTyped(json, false);
}
export function PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'readingLevel': json['readingLevel'],
        'sisId': json['sisId'],
        'studentId': json['studentId'],
    };
}
export function PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'readingLevel': value['readingLevel'],
        'sisId': value['sisId'],
        'studentId': value['studentId'],
    };
}
